/* ============================================================
   Sidebar navigation icons

   One consistent outline set (Lucide, via react-icons) so the rail
   doesn't mix filled and stroked glyphs at different weights. The
   local .svg icons stay where they are — they're still used inside
   pages (log tabs, table actions) and carry their own baked styling.
   ============================================================ */

import React, { SVGProps } from "react";
import { IconType } from "react-icons";
import {
  LuLayoutDashboard,
  LuFileText,
  LuInbox,
  LuTicket,
  LuScrollText,
  LuUserCheck,
  LuMegaphone,
  LuUsers,
  LuWallet,
  LuBell,
  LuLifeBuoy,
  LuCalendarClock,
  LuMonitorPlay,
  LuGraduationCap,
  LuUser,
} from "react-icons/lu";

/* Routes type the icon as an SVG component, so wrap each react-icon in
   one. Stroke is thinned from Lucide's default 2 — at 20px, 1.6 reads
   lighter next to 14px menu labels. */
const navIcon = (Icon: IconType): React.FC<SVGProps<SVGSVGElement>> => {
  const Wrapped: React.FC<SVGProps<SVGSVGElement>> = (props) => (
    <Icon
      size={20}
      strokeWidth={1.6}
      aria-hidden
      {...(props as Record<string, unknown>)}
    />
  );
  return Wrapped;
};

export const NavHomeIcon = navIcon(LuLayoutDashboard);
export const NavExamIcon = navIcon(LuFileText);
export const NavRequestIcon = navIcon(LuInbox);
export const NavVoucherIcon = navIcon(LuTicket);
export const NavLogsIcon = navIcon(LuScrollText);
export const NavExaminerIcon = navIcon(LuUserCheck);
export const NavAnnouncementIcon = navIcon(LuMegaphone);
export const NavUserIcon = navIcon(LuUsers);
export const NavFinanceIcon = navIcon(LuWallet);
export const NavNotificationIcon = navIcon(LuBell);
export const NavSupportIcon = navIcon(LuLifeBuoy);
export const NavScheduleSessionIcon = navIcon(LuCalendarClock);
export const NavMySessionIcon = navIcon(LuMonitorPlay);
export const NavMyExamIcon = navIcon(LuGraduationCap);
export const NavProfileIcon = navIcon(LuUser);
